module.exports = __webpack_public_path__ + "img/alarm.91156736.svg";